// extracted by mini-css-extract-plugin
export default {"tooltip":"GM-z","arrow":"HM-z"};